// removed by extract-text-webpack-plugin
module.exports = {"news-section":"_1b51RW7y","newsSection":"_1b51RW7y","icon":"aXJY7xuV","items":"_28wupif5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewsSection/NewsSection.pcss
// module id = 418
// module chunks = 0